import * as Sentry from '@sentry/nuxt'

Sentry.init({
  dsn: 'https://2faae282fde245a4a1b587aa67036ec2@o357760.ingest.sentry.io/6191489',
  enabled: process.env.NODE_ENV === 'production',
  release: 'web:' + (process.env.GITREF || 'dev'),
  environment: process.env.GITREF?.split('-')[0] || 'unknown',
  integrations: [
    Sentry.replayIntegration(),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: 0.1,
})
